import { css } from 'react-emotion';

const styles = {
	button__apply: css`
		min-height: 32px !important;
		min-width: 100px !important;
		padding: 4px !important;
		text-align: left;
		.c-a-button__title {
			font-size: 14px !important;
			margin-left: 0 !important;
			margin-right: 0 !important;
		}
	`,
	button__container: css`
		flex-basis: 100%;
	`,
	container: css`
		padding-bottom: 1rem;
		padding-top: 1rem;
		.c-m-form-field {
			margin-bottom: 0;
		}
		.c-m-payment-control {
			min-width: 200px;
		}
		.c-m-payment-control__selected {
			border: 1px solid #222;
			padding: 6px 6px 8px;
		}
		.c-m-payment-control__selected-name,
		.c-m-payment-control__selected-meta {
			font-size: 16px;
		}
		.c-o-list-payment__total {
			border: none;
			text-align: left;
			background-color: #f1f1f1;
			padding: 16px;
		}
		.c-o-list-payment__total-label {
			text-align: left;
			min-width: 75px;
			@media (min-width: 840px) {
				min-width: 150px;
			}
			@media (min-width: 960px) {
				min-width: 240px;
			}
		}
		.c-o-list-payment__total-value {
			text-align: left;
		}
		.c-o-list-payment__input-with-fix {
			min-width: 165px;
		}
	`,
	fade__transition: css`
		&-enter {
			opacity: 0;
			transition: opacity 0.5s ease-in;
		}
		&-enter-active {
			opacity: 1;
		}
		&-leave {
			max-height: 56px;
			overflow: hidden;
			transition: max-height 0.2s ease-in;
		}
		&-leave-active {
			max-height: 0;
		}
	`,
	main__container: css`
		.c-m-payment-control__selected {
			margin-top: 4px;
		}
		.c-m-payment-control__selected-name {
			font-size: 16px;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.c-m-payment-control__selected-meta {
			font-size: 16px;
		}

		.o-block-field {
			max-width: 100%;
		}
		.c-o-list-payment__row-label {
			display: none;
		}
	`,
	main__description: css`
		display: block;
		font-size: 0.75rem;
		line-height: 1.5;
		margin: 0.25rem 0;
	`,
	main__input: css`
		border: 1px solid #222;
		border-radius: 2px;
		box-sizing: border-box;
		font-size: 1rem;
		padding: 0.75rem;
		width: 100%;
		min-width: 100px;
	`,
	main__popper: css`
		@media (min-width: 768px) {
			display: none;

			&.first-row {
				display: block;
			}
		}
	`,

	main__deleteContainer: css`
		position: relative;

		@media (max-width: 766px) {
			width: 100%;
			height: 40px;
		}
	`,

	main__delete: css`
		left: 45%;

		@media (min-width: 768px) {
			position: absolute;
			right: 4%;
			top: -80%;
			left: unset;

			&:hover {
				svg {
					fill: #222;
				}
			}
		}

		@media (min-width: 840px) {
			top: 0;
			flex-grow: 0;
			position: relative;

			&.first-row {
				top: 56px;
			}
		}
	`,
	main__inputLabel: css`
		font-size: 0.9em;
		@media (min-width: 840px) {
			display: none;
		}
	`,
	main__validation: css`
		display: block;
		line-height: 1;
		margin: 0.25rem 0;
		p {
			font-size: 0.75rem;
			line-height: 1.5;
		}
	`,
	paymentRow: css`
		margin-bottom: 8px;

		.c-m-payment-control__selected {
			border: 1px solid #222;
			padding: 4px 6px 8px;
		}
		@media (max-width: 840px) {
			border-bottom: 1px solid #e8e8e8;
			margin-bottom: 16px;
			padding-bottom: 16px;
		}
	`,
	payments__container: css`
		background: #f7f7f7;
		padding: 1rem 0;
		.add-payment {
			justify-content: center;
			.c-a-button__title {
				flex: 0 1 auto;
			}
		}
		@media (max-width: 998px) {
			.c-o-list-payment__row-cell--to {
				min-width: 150px;
			}
		}
		@media (max-width: 1279px) {
			.c-o-list-payment__row-label {
				display: none;
			}
			.c-o-list-payment__row-cell,
			.c-o-list-payment__row-cell--to {
				padding: 2px 0;
			}
		}
	`,
	payments__labels: css`
		@media (min-width: 840px) {
			display: none;
		}
	`,
	payments__table: css`
		width: 100%;

		&,
		tr,
		td {
			border: 0;
			padding: 4px;
			@media (max-width: 839px) {
				display: block;
			}
		}
		@media (max-width: 839px) {
			tr {
				border-bottom: 1px solid #c1c1c1;
			}
		}

		& th {
			border: 0;
			padding: 10px 8px;
			@media (max-width: 839px) {
				display: none;
			}
		}

		.total-row {
			background-color: white;
			border-radius: 2px;
			padding: 16px 8px;

			td {
				padding: 16px;
				@media (max-width: 839px) {
					display: inline-table;
					width: 100px;
					font-size: 1.1em;
					font-weight: bold;
				}
			}
		}

		.table-head-label {
			font-size: 0.9em;
			@media (max-width: 839px) {
				display: none;
			}
		}

		.delete-button-cell {
			@media (max-width: 839px) {
				text-align: right;
			}
		}
	`,
	static__field: css`
		align-items: center;
		display: flex;
		font-family: 'Source-Sans-Pro Text Bold', sans-serif;
		min-height: 48px;
		background: #f7f7f7;
		padding: 0 8px;
		border-radius: 2px;
		min-width: 120px;
	`,
	static__field__max__width: css`
		align-items: center;
		display: flex;
		font-family: 'Source-Sans-Pro Text Bold', sans-serif;
		min-height: 48px;
		background: #f7f7f7;
		padding: 0 8px;
		border-radius: 2px;
		min-width: 120px;
		max-width: 240px;
	`,
	field__label: css`
		display: flex;
		flex-wrap: nowrap;
		span {
			display: inline-block;
			font-size: 15px;
			max-width: calc(100% - 32px);
		}
	`,
	row__wrapper: css`
		margin-bottom: 8px;
	`,
};

export default styles;
